import { PAYMENT_STATUS, ATTENDANCE_STATUS } from "@/lib/format";

export function PaymentBadge({ status }) {
  const s = PAYMENT_STATUS[status] || { label: status, cls: "bg-slate-100 text-slate-700 border-slate-200" };
  return <span className={`inline-flex items-center rounded border px-2 py-0.5 text-xs font-semibold ${s.cls}`} data-testid="payment-status-badge">{s.label}</span>;
}

export function AttendanceBadge({ status }) {
  if (!status) return <span className="text-xs text-slate-400">Belum dicatat</span>;
  return <span className={`inline-flex rounded border px-2 py-0.5 text-xs font-semibold capitalize ${ATTENDANCE_STATUS[status] || ""}`}>{status}</span>;
}

export function Pill({ children, tone = "slate" }) {
  const tones = {
    slate: "bg-slate-100 text-slate-700 border-slate-200",
    green: "bg-emerald-50 text-emerald-700 border-emerald-200",
    amber: "bg-amber-50 text-amber-800 border-amber-200",
    red: "bg-red-50 text-red-700 border-red-200",
    navy: "bg-slate-900 text-white border-slate-900",
  };
  return <span className={`inline-flex items-center rounded border px-2 py-0.5 text-xs font-semibold ${tones[tone]}`}>{children}</span>;
}
